import React, {useEffect, useMemo, useState} from 'react'
import {mapRecompraProgramadaToTable, recompraProgramadaFields} from "./recompra-programada-fields"
import {Paper} from "@mui/material"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import PropTypes from "prop-types"
import {copyTable, pasteTableFromClipboard} from "../../../../utils/csv-utils"
import {useLocation} from "react-router-dom"
import MotorRecompraProgramadaService from "../../../../../../../services/motor-recompra-programada-service"

const RecompraTable = ({
                           setLoading,
                           idCaracteristica,
                           recompraPublicado,
                           tableData,
                           setTableData,
                           clearTable
                       }) => {

    const service = useMemo(() => new MotorRecompraProgramadaService(), [])
    const [tableKey, setTableKey] = useState(Math.random() * 10)
    const location = useLocation()
    const navigationState = location.state

    useEffect(() => {
        if (!idCaracteristica) return

        const origem = navigationState?.origem
        if (origem === "ver") {
            loadRecompraProgramada()
        }
    }, [idCaracteristica, navigationState])

    useEffect(() => {
        if (navigationState?.origem !== "duplicar") return
        const dadosOrigem =
            navigationState?.Data?.RecompraProgramada?.RecomprasProgramadas ?? []
        
        const formatted = mapRecompraProgramadaToTable(dadosOrigem)
        recompraPublicado(false)
        setTableData(formatted)
        setTableKey(Math.random() * 10)
        console.log(
            "NAVIGATION DATA:",
            navigationState?.Data
        )

        console.log(
            "RECOMPRAS:",
            navigationState?.Data?.RecomprasProgramadas
        )   
    }, [navigationState, recompraPublicado, setTableData])

    const loadRecompraProgramada = () => {
        setLoading(true)

        service.getRecompraProgramada(idCaracteristica)
            .then(response => {
                const {body} = response
                const {RecomprasProgramadas} = body

                if (RecomprasProgramadas.length > 0) {
                    recompraPublicado(true)
                    const formatted = mapRecompraProgramadaToTable(RecomprasProgramadas)
                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    loadRecompraProgramadaTemporario()
                }
            })
            .catch(error => console.error("Erro getRecompraProgramada:", error))
            .finally(() => setLoading(false))
    }

    const loadRecompraProgramadaTemporario = () => {
        setLoading(true)

        service.getTemporarioRecompraProgramada(idCaracteristica)
            .then(response => {
                const bodyTemp = response?.body || response?.data

                if (bodyTemp) {
                    const recompras = Array.isArray(bodyTemp)
                        ? bodyTemp
                        : bodyTemp?.RecomprasProgramadas || []

                    const formatted = mapRecompraProgramadaToTable(recompras)

                    setTableData(formatted)
                    setTableKey(Math.random() * 10)
                } else {
                    console.warn("Nenhum dado temporário encontrado")
                }
            })
            .catch(error => console.error("Erro getTemporarioRecompraProgramada:", error))
            .finally(() => setLoading(false))
    }

    return (
        <Paper sx={{mt: 2}}>
            <DynamicColumnTable
                key={tableKey}
                actionButtons={true}
                copyData={() => copyTable(tableData, recompraProgramadaFields)}
                pasteData={async () => await pasteTableFromClipboard(recompraProgramadaFields, setTableData)}
                clearTable={() => clearTable(setTableData)}
                fields={recompraProgramadaFields}
                items={tableData}
                setItems={setTableData}
            />
        </Paper>
    )
}

RecompraTable.propTypes = {
    setLoading: PropTypes.bool,
    idCaracteristica: PropTypes.number,
    recompraPublicado: PropTypes.func,
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    clearTable: PropTypes.func,
}

export default RecompraTable